module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst additionalAttributes = []\nconst additionalClasses = []\nconst renderMode = ((storage || {}).request || {}).renderMode || ''\nconst meta = (model.documentData || {}).meta || {}\nconst document = meta.document || {}\nconst projectTermRange = meta.projectTermRange || {}\nlet projectTimeRange = utils.moment(projectTermRange.minStartTS).format('DD.MM.YYYY')\nif(projectTermRange.maxStartTS && projectTermRange.minStartTS !== projectTermRange.maxStartTS){\nprojectTimeRange = `${projectTimeRange} - ${utils.moment(projectTermRange.maxStartTS).format('DD.MM.YYYY')}`\n}\nconst projectTitleParts = []\nif(document.projectID)  projectTitleParts.push(`#${document.projectID}`);\nif(document.title)      projectTitleParts.push(document.title);\nconst projectTitle = projectTitleParts.join(' ')\nconst customer = document.customer || {}\nlet customerName = ''\nif(customer.customerID){\ncustomerName = customer.companyName || ''\n}\nconst customerContact = document.customerContact || {}\nlet customerContactName = ''\nif(customerContact.customerContactID){\nconst parts = []\nif(customerContact.title)       parts.push(customerContact.title);\nif(customerContact.firstname)   parts.push(customerContact.firstname);\nif(customerContact.lastname)    parts.push(customerContact.lastname);\nif(parts.length > 0){\ncustomerContactName = parts.join(' ')\n}\n}\nlet customerZipCity = ''\nconst customerZipCityParts = []\nif(customer.zip)    customerZipCityParts.push(customer.zip);\nif(customer.city)   customerZipCityParts.push(customer.city);\ncustomerZipCity = customerZipCityParts.join(' ');\nlet customerContactZipCity = ''\nconst customerContactZipCityParts = []\nif(customerContact.zip)    customerContactZipCityParts.push(customerContact.zip);\nif(customerContact.city)   customerContactZipCityParts.push(customerContact.city);\ncustomerContactZipCity = customerContactZipCityParts.join(' ');\nconst sourceAddressParts = []\nconst fromEmployee = document.fromEmployee || {}\nif(fromEmployee.employeeID){\n// TODO: IMPL\n} else {\nif(model.sourceAddress)                 sourceAddressParts.push(`<div class=\"main\">${String(model.sourceAddress).replace(/\\n/g, '<br>')}</div>`);\nif(model.sourceAddressContact)          sourceAddressParts.push(`<div class=\"contact\">${String(model.sourceAddressContact).replace(/\\n/g, '<br>')}</div>`);\nif(model.sourceAddressMiscellaneous)    sourceAddressParts.push(`<div class=\"miscellaneous\">${String(model.sourceAddressMiscellaneous).replace(/\\n/g, '<br>')}</div>`);\n}\nconst sourceAddress = sourceAddressParts.join('')\nlet targetAddress = ''\nconst targetAddressParts = []\nif(customerName)        targetAddressParts.push(customerName);\nif(customerContactName) targetAddressParts.push(`z.H.: ${customerContactName}`);\nif(customerContact.street){\ntargetAddressParts.push(customerContact.street);\nif(customerContactZipCity)     targetAddressParts.push(customerContactZipCity);\nif(customerContact.country)    targetAddressParts.push(customerContact.country);\n} else {\nif(customer.street)     targetAddressParts.push(customer.street);\nif(customerZipCity)     targetAddressParts.push(customerZipCity);\nif(customer.country)    targetAddressParts.push(customer.country);\n}\nif(customer.companyTaxNumber) targetAddressParts.push(`UID: ${customer.companyTaxNumber}`);\ntargetAddress = targetAddressParts.join('<br>')\nconst projectSubTitleParts = []\nif(projectTitle)                projectSubTitleParts.push(`${storage.__('document.invoice.projectTitle')}: ${projectTitle}`);\nif(projectTimeRange)            projectSubTitleParts.push(`${storage.__('document.invoice.timeRange')}: ${projectTimeRange}`);\nconst projectSubTitle = projectSubTitleParts.join('<br>')\nconst customerNumberParts = []\nlet customerNumbers = ''\nif(customer.customerNumber){\ncustomerNumberParts.push(storage.__('document.shippingOrder.customerNumber', { value: customer.customerNumber }))\n}\nif(document.customerReference){\ncustomerNumberParts.push(document.customerReference)\n}\ncustomerNumbers = customerNumberParts.join('<br>')\nlet documentDate = ''\nif(document.invoiceTS){\ndocumentDate = `Wien, am ${utils.moment(document.invoiceTS).format('DD. MMMM YYYY')}`\n}\nconst isCanceled = !!document.canceledAt\nif(renderMode === 'html'){\nadditionalClasses.push('styleTableWithoutBackground')\n}\nif(additionalClasses.length > 0){\nadditionalAttributes.push(`class=\"${additionalClasses.join(' ')}\"`)\n}\n%><div <%- additionalAttributes.join(' ') %>>\n<section class=\"controls\">\n<!-- extra management control buttons may be needed in the future -->\n</section>\n<section class=\"sheet\">\n<%- include('./header', { model }) %>\n<section class=\"body\">\n<div class=\"general\">\n<table>\n<tbody>\n<tr>\n<td class=\"targetAddress\"><%- targetAddress %></td>\n<td class=\"sourceAddress\"><%- sourceAddress %></td>\n</tr>\n</tbody>\n<tbody>\n<tr class=\"titleRow\">\n<td class=\"title\"><%= storage.__('document.invoice.head') %></td>\n<td class=\"number\"><%= storage.__('document.invoice.number', { value: document.number }) %></td>\n</tr>\n</tbody>\n<tbody>\n<tr>\n<td class=\"subTitle\"><%- projectSubTitle %></td>\n<td class=\"customerNumber\"><%\nif(customerNumbers){\n%><%- customerNumbers %><%\n}\n%></td>\n</tr>\n</tbody>\n<tbody>\n<tr>\n<td>&nbsp;</td>\n</tr>\n</tbody>\n<tbody>\n<tr>\n<td colspan=\"2\" class=\"documentDate\"><%- documentDate %></td>\n</tr>\n</tbody>\n</table>\n</div>\n<% if(isCanceled){ %>\n<div class=\"watermark\">\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"500\" height=\"160\" viewBox=\"0 0 500 160\"><path d=\"M478.5,148.14H24.78c-.94,0-1.88,0-2.82,0-.14,0-.28,0-.42,0a10.28,10.28,0,0,1-7.81-3.9c-2.09-2.93-2-5-2-8.65V85.92c0-21.28-.16-42.57,0-63.85a10,10,0,0,1,9.77-10.2H453c8.38,0,16.76-.06,25.14,0a9.84,9.84,0,0,1,8.72,4.7,9.39,9.39,0,0,1,1.44,5.5V131c0,2.33,0,4.65,0,7a10,10,0,0,1-9.77,10.2c-7.53.17-7.55,12,0,11.85A21.93,21.93,0,0,0,500,138.26c0-1.83,0-3.66,0-5.49V25.29c0-3.28.07-6.54-.89-9.74A21.87,21.87,0,0,0,478.45,0c-2.15,0-4.3,0-6.44,0H22.79c-.87,0-1.73,0-2.6.05A21.93,21.93,0,0,0,.05,21.77c-.12,6.62,0,13.25,0,19.87V134.9c0,3.44,0,6.86,1.09,10.19A21.88,21.88,0,0,0,21.6,160c.66,0,1.32,0,2,0H478.5C486,160,486.06,148.14,478.5,148.14Z\" style=\"fill:#c1272d\"/><text style=\"font-size:80px;fill:#c1272d;font-family:OpenSans-Bold, Open Sans;font-weight:700;\" dy=\"28\" x=\"50%\" y=\"50%\" text-anchor=\"middle\">Storno</text></svg>\n</div>\n<% } %>\n<%- helpers.renderSection('content') %>\n</section>\n<%- include('./footer', { model }) %>\n</section>\n<section class=\"controls\">\n<!-- extra management control buttons may be needed in the future -->\n</section>\n</div>"
  , __filename = "components/templates/core/documents/invoice/invoice.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const additionalAttributes = []
const additionalClasses = []
const renderMode = ((storage || {}).request || {}).renderMode || ''
const meta = (model.documentData || {}).meta || {}
const document = meta.document || {}
const projectTermRange = meta.projectTermRange || {}
let projectTimeRange = utils.moment(projectTermRange.minStartTS).format('DD.MM.YYYY')
if(projectTermRange.maxStartTS && projectTermRange.minStartTS !== projectTermRange.maxStartTS){
projectTimeRange = `${projectTimeRange} - ${utils.moment(projectTermRange.maxStartTS).format('DD.MM.YYYY')}`
}
const projectTitleParts = []
if(document.projectID)  projectTitleParts.push(`#${document.projectID}`);
if(document.title)      projectTitleParts.push(document.title);
const projectTitle = projectTitleParts.join(' ')
const customer = document.customer || {}
let customerName = ''
if(customer.customerID){
customerName = customer.companyName || ''
}
const customerContact = document.customerContact || {}
let customerContactName = ''
if(customerContact.customerContactID){
const parts = []
if(customerContact.title)       parts.push(customerContact.title);
if(customerContact.firstname)   parts.push(customerContact.firstname);
if(customerContact.lastname)    parts.push(customerContact.lastname);
if(parts.length > 0){
customerContactName = parts.join(' ')
}
}
let customerZipCity = ''
const customerZipCityParts = []
if(customer.zip)    customerZipCityParts.push(customer.zip);
if(customer.city)   customerZipCityParts.push(customer.city);
customerZipCity = customerZipCityParts.join(' ');
let customerContactZipCity = ''
const customerContactZipCityParts = []
if(customerContact.zip)    customerContactZipCityParts.push(customerContact.zip);
if(customerContact.city)   customerContactZipCityParts.push(customerContact.city);
customerContactZipCity = customerContactZipCityParts.join(' ');
const sourceAddressParts = []
const fromEmployee = document.fromEmployee || {}
if(fromEmployee.employeeID){
// TODO: IMPL
} else {
if(model.sourceAddress)                 sourceAddressParts.push(`<div class="main">${String(model.sourceAddress).replace(/\n/g, '<br>')}</div>`);
if(model.sourceAddressContact)          sourceAddressParts.push(`<div class="contact">${String(model.sourceAddressContact).replace(/\n/g, '<br>')}</div>`);
if(model.sourceAddressMiscellaneous)    sourceAddressParts.push(`<div class="miscellaneous">${String(model.sourceAddressMiscellaneous).replace(/\n/g, '<br>')}</div>`);
}
const sourceAddress = sourceAddressParts.join('')
let targetAddress = ''
const targetAddressParts = []
if(customerName)        targetAddressParts.push(customerName);
if(customerContactName) targetAddressParts.push(`z.H.: ${customerContactName}`);
if(customerContact.street){
targetAddressParts.push(customerContact.street);
if(customerContactZipCity)     targetAddressParts.push(customerContactZipCity);
if(customerContact.country)    targetAddressParts.push(customerContact.country);
} else {
if(customer.street)     targetAddressParts.push(customer.street);
if(customerZipCity)     targetAddressParts.push(customerZipCity);
if(customer.country)    targetAddressParts.push(customer.country);
}
if(customer.companyTaxNumber) targetAddressParts.push(`UID: ${customer.companyTaxNumber}`);
targetAddress = targetAddressParts.join('<br>')
const projectSubTitleParts = []
if(projectTitle)                projectSubTitleParts.push(`${storage.__('document.invoice.projectTitle')}: ${projectTitle}`);
if(projectTimeRange)            projectSubTitleParts.push(`${storage.__('document.invoice.timeRange')}: ${projectTimeRange}`);
const projectSubTitle = projectSubTitleParts.join('<br>')
const customerNumberParts = []
let customerNumbers = ''
if(customer.customerNumber){
customerNumberParts.push(storage.__('document.shippingOrder.customerNumber', { value: customer.customerNumber }))
}
if(document.customerReference){
customerNumberParts.push(document.customerReference)
}
customerNumbers = customerNumberParts.join('<br>')
let documentDate = ''
if(document.invoiceTS){
documentDate = `Wien, am ${utils.moment(document.invoiceTS).format('DD. MMMM YYYY')}`
}
const isCanceled = !!document.canceledAt
if(renderMode === 'html'){
additionalClasses.push('styleTableWithoutBackground')
}
if(additionalClasses.length > 0){
additionalAttributes.push(`class="${additionalClasses.join(' ')}"`)
}

    ; __line = 91
    ; __append("<div ")
    ; __append( additionalAttributes.join(' ') )
    ; __append(">\n<section class=\"controls\">\n<!-- extra management control buttons may be needed in the future -->\n</section>\n<section class=\"sheet\">\n")
    ; __line = 96
    ; __append( include('./header', { model }) )
    ; __append("\n<section class=\"body\">\n<div class=\"general\">\n<table>\n<tbody>\n<tr>\n<td class=\"targetAddress\">")
    ; __line = 102
    ; __append( targetAddress )
    ; __append("</td>\n<td class=\"sourceAddress\">")
    ; __line = 103
    ; __append( sourceAddress )
    ; __append("</td>\n</tr>\n</tbody>\n<tbody>\n<tr class=\"titleRow\">\n<td class=\"title\">")
    ; __line = 108
    ; __append(escapeFn( storage.__('document.invoice.head') ))
    ; __append("</td>\n<td class=\"number\">")
    ; __line = 109
    ; __append(escapeFn( storage.__('document.invoice.number', { value: document.number }) ))
    ; __append("</td>\n</tr>\n</tbody>\n<tbody>\n<tr>\n<td class=\"subTitle\">")
    ; __line = 114
    ; __append( projectSubTitle )
    ; __append("</td>\n<td class=\"customerNumber\">")
    ; __line = 115
    ; 
if(customerNumbers){

    ; __line = 117
    ; __append( customerNumbers )
    ; 
}

    ; __line = 119
    ; __append("</td>\n</tr>\n</tbody>\n<tbody>\n<tr>\n<td>&nbsp;</td>\n</tr>\n</tbody>\n<tbody>\n<tr>\n<td colspan=\"2\" class=\"documentDate\">")
    ; __line = 129
    ; __append( documentDate )
    ; __append("</td>\n</tr>\n</tbody>\n</table>\n</div>\n")
    ; __line = 134
    ;  if(isCanceled){ 
    ; __append("\n<div class=\"watermark\">\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"500\" height=\"160\" viewBox=\"0 0 500 160\"><path d=\"M478.5,148.14H24.78c-.94,0-1.88,0-2.82,0-.14,0-.28,0-.42,0a10.28,10.28,0,0,1-7.81-3.9c-2.09-2.93-2-5-2-8.65V85.92c0-21.28-.16-42.57,0-63.85a10,10,0,0,1,9.77-10.2H453c8.38,0,16.76-.06,25.14,0a9.84,9.84,0,0,1,8.72,4.7,9.39,9.39,0,0,1,1.44,5.5V131c0,2.33,0,4.65,0,7a10,10,0,0,1-9.77,10.2c-7.53.17-7.55,12,0,11.85A21.93,21.93,0,0,0,500,138.26c0-1.83,0-3.66,0-5.49V25.29c0-3.28.07-6.54-.89-9.74A21.87,21.87,0,0,0,478.45,0c-2.15,0-4.3,0-6.44,0H22.79c-.87,0-1.73,0-2.6.05A21.93,21.93,0,0,0,.05,21.77c-.12,6.62,0,13.25,0,19.87V134.9c0,3.44,0,6.86,1.09,10.19A21.88,21.88,0,0,0,21.6,160c.66,0,1.32,0,2,0H478.5C486,160,486.06,148.14,478.5,148.14Z\" style=\"fill:#c1272d\"/><text style=\"font-size:80px;fill:#c1272d;font-family:OpenSans-Bold, Open Sans;font-weight:700;\" dy=\"28\" x=\"50%\" y=\"50%\" text-anchor=\"middle\">Storno</text></svg>\n</div>\n")
    ; __line = 138
    ;  } 
    ; __append("\n")
    ; __line = 139
    ; __append( helpers.renderSection('content') )
    ; __append("\n</section>\n")
    ; __line = 141
    ; __append( include('./footer', { model }) )
    ; __append("\n</section>\n<section class=\"controls\">\n<!-- extra management control buttons may be needed in the future -->\n</section>\n</div>")
    ; __line = 146
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/documents/invoice/invoice.ejs

}